module.exports = __webpack_public_path__ + "static/media/red_hackru_notif.1dd40218.png";